module.exports = __webpack_public_path__ + "lato-light-webfont.ecbd94f03d883ee5730b.eot";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-light-webfont.eot
// module id = ../../../../../resources/layout/fonts/lato-light-webfont.eot
// module chunks = styles